<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="所属厂区" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="factoryId">
              <a-select  placeholder="请选择所属厂区" v-model="model.factoryId" >
                <a-select-option
                  v-for="d in factoryOptions"
                  :key="d.id"
                  :value="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>              
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="区域编码" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="code">
              <a-input v-model="model.code" placeholder="请输入区域编码"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="区域名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
              <a-input v-model="model.name" placeholder="请输入区域名称"  ></a-input>
            </a-form-model-item>
          </a-col>          
          <!-- <a-col :span="24">
            <a-form-model-item label="是否启用" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="status">
              <j-switch v-model="model.status" ></j-switch>
            </a-form-model-item>
          </a-col> -->
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'

  export default {
    name: 'PreAreaForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
          status:'Y'
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        factoryOptions:[],
        validatorRules: {
           code: [
              { required: true, message: '请输入区域编码!'},
           ],
           name: [
              { required: true, message: '请输入区域名称!'},
           ],
           factoryId: [
              { required: true, message: '请输入所属厂区id!'},
           ],
           status: [
              { required: true, message: '请输入是否启用!'},
           ],
        },
        url: {
          list: "/prevent/factory/prefactorys",
          add: "/prevent/area/preareaAdd",
          edit: "/prevent/area/preareaEdit",
          queryById: "/prevent/area/preareaQueryById/"
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      this.loadData();
    },
    methods: {
      loadData(){
        this.loading = true
        let params = {pageNo:1,pageSize:100000};
        return new Promise((resolve) => {
          getAction(this.url.list,params).then(res=>{
            if(res.success){
              let result = res.result
              if(Number(result.total)>0){                                       
                this.factoryOptions = result.records.map(item=>{
                    let c ={id:item.id, name: item.name}
                    return c;
                });              
              }
            }else{
              this.$message.warning(res.message)
            }
          }).finally(()=>{
            this.loading = false
          })
        })
      },
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>
